import {NgModule} from '@angular/core';
import {ClientDashboardSharedModule} from '../dashboard/client-dashboard-shared.module';

@NgModule({
    imports: [
        ClientDashboardSharedModule
    ]
})
export class WidgetPageEnvModule {}
